exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AddSale.scss?vue&type=style&index=0&id=1366c52d&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
